import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import * as S from './CardLayoutStyled';

const CardLayoutHeaderSkeleton = () => (
  <S.SkeletonContainer>
    <Skeleton width={260} height={148} />
    <div>
      <Skeleton width={418} height={20} />
      <Skeleton width={418} height={20} />
      <Skeleton width={418} height={20} />
    </div>
    <div>
      <Skeleton width={418} height={20} />
      <Skeleton width={418} height={20} />
      <Skeleton width={418} height={20} />
    </div>
  </S.SkeletonContainer>
);

export default CardLayoutHeaderSkeleton;
